export var ShipmentRouteState;
(function (ShipmentRouteState) {
    ShipmentRouteState["Draft"] = "Draft";
    ShipmentRouteState["Created"] = "Created";
    ShipmentRouteState["InProgress"] = "InProgress";
    ShipmentRouteState["Completed"] = "Completed";
    ShipmentRouteState["Canceled"] = "Canceled";
})(ShipmentRouteState || (ShipmentRouteState = {}));
export var ShipmentDraftState;
(function (ShipmentDraftState) {
    ShipmentDraftState["Draft"] = "Draft";
    ShipmentDraftState["Created"] = "Created";
    ShipmentDraftState["Completed"] = "Completed";
    ShipmentDraftState["Canceled"] = "Canceled";
})(ShipmentDraftState || (ShipmentDraftState = {}));
export var ShipmentItemBoxState;
(function (ShipmentItemBoxState) {
    ShipmentItemBoxState["None"] = "None";
    ShipmentItemBoxState["Loaded"] = "Loaded";
    ShipmentItemBoxState["Unloaded"] = "Unloaded";
})(ShipmentItemBoxState || (ShipmentItemBoxState = {}));
export var ShipmentItemType;
(function (ShipmentItemType) {
    ShipmentItemType["Inbound"] = "Inbound";
    ShipmentItemType["Outbound"] = "Outbound";
    ShipmentItemType["InboundOutbound"] = "InboundOutbound";
    ShipmentItemType["PackingLine"] = "PackingLine";
})(ShipmentItemType || (ShipmentItemType = {}));
export var ShipmentRulePriorityEvaluationType;
(function (ShipmentRulePriorityEvaluationType) {
    ShipmentRulePriorityEvaluationType["Product"] = "Product";
    ShipmentRulePriorityEvaluationType["DestinationPoint"] = "DestinationPoint";
})(ShipmentRulePriorityEvaluationType || (ShipmentRulePriorityEvaluationType = {}));
export var ShipmentType;
(function (ShipmentType) {
    ShipmentType["Shipment"] = "Shipment";
    ShipmentType["Carrier"] = "Carrier";
})(ShipmentType || (ShipmentType = {}));
export var ShipmentStopState;
(function (ShipmentStopState) {
    ShipmentStopState["Created"] = "Created";
    ShipmentStopState["Arrived"] = "Arrived";
    ShipmentStopState["Completed"] = "Completed";
    ShipmentStopState["Skipped"] = "Skipped";
    ShipmentStopState["Canceled"] = "Canceled";
})(ShipmentStopState || (ShipmentStopState = {}));
export var ShipmentStopType;
(function (ShipmentStopType) {
    ShipmentStopType["Start"] = "Start";
    ShipmentStopType["Stop"] = "Stop";
    ShipmentStopType["Pickup"] = "Pickup";
    ShipmentStopType["Delivery"] = "Delivery";
    ShipmentStopType["End"] = "End";
})(ShipmentStopType || (ShipmentStopType = {}));
export var ShipmentItemPlanState;
(function (ShipmentItemPlanState) {
    ShipmentItemPlanState["Unplanned"] = "Unplanned";
    ShipmentItemPlanState["Planned"] = "Planned";
})(ShipmentItemPlanState || (ShipmentItemPlanState = {}));
export var ShipmentItemState;
(function (ShipmentItemState) {
    ShipmentItemState["WaitingForOutbound"] = "WaitingForOutbound";
    ShipmentItemState["Created"] = "Created";
    // Unpicked = 'Unpicked',
    // Planned = 'Planned',
    ShipmentItemState["Loaded"] = "Loaded";
    ShipmentItemState["InDelivery"] = "InDelivery";
    ShipmentItemState["Unloaded"] = "Unloaded";
    ShipmentItemState["Completed"] = "Completed";
    ShipmentItemState["Skipped"] = "Skipped";
    ShipmentItemState["Canceled"] = "Canceled";
})(ShipmentItemState || (ShipmentItemState = {}));
export var ShipmentState;
(function (ShipmentState) {
    ShipmentState["Unplanned"] = "Unplanned";
    ShipmentState["Planned"] = "Planned";
    ShipmentState["Created"] = "Created";
    ShipmentState["Loaded"] = "Loaded";
    ShipmentState["InDelivery"] = "InDelivery";
    ShipmentState["Unloaded"] = "Unloaded";
    ShipmentState["Completed"] = "Completed";
    ShipmentState["Skipped"] = "Skipped";
    ShipmentState["Canceled"] = "Canceled";
    ShipmentState["CanceledOnCheck"] = "CanceledOnCheck";
})(ShipmentState || (ShipmentState = {}));
export var ShipmentItemAction;
(function (ShipmentItemAction) {
    ShipmentItemAction["Load"] = "Load";
    ShipmentItemAction["Unload"] = "Unload";
})(ShipmentItemAction || (ShipmentItemAction = {}));
export var InboundRequestShipmentState;
(function (InboundRequestShipmentState) {
    InboundRequestShipmentState["None"] = "None";
    InboundRequestShipmentState["Waiting"] = "Waiting";
    InboundRequestShipmentState["InProgress"] = "InProgress";
    InboundRequestShipmentState["PartiallyCompleted"] = "PartiallyCompleted";
    InboundRequestShipmentState["Completed"] = "Completed";
})(InboundRequestShipmentState || (InboundRequestShipmentState = {}));
export var ShipmentPlanOutboundDocumentViewType;
(function (ShipmentPlanOutboundDocumentViewType) {
    ShipmentPlanOutboundDocumentViewType["All"] = "all";
    ShipmentPlanOutboundDocumentViewType["OnlyForThisRoute"] = "onlyForThisRoute";
    ShipmentPlanOutboundDocumentViewType["OnlyForThisRouteWithoutErrors"] = "onlyForThisRouteWithoutErrors";
})(ShipmentPlanOutboundDocumentViewType || (ShipmentPlanOutboundDocumentViewType = {}));
export var ShipmentRouteStepType;
(function (ShipmentRouteStepType) {
    ShipmentRouteStepType["Start"] = "start";
    ShipmentRouteStepType["Job"] = "job";
    ShipmentRouteStepType["End"] = "end";
    ShipmentRouteStepType["Pickup"] = "pickup";
    ShipmentRouteStepType["Delivery"] = "delivery";
})(ShipmentRouteStepType || (ShipmentRouteStepType = {}));
//# sourceMappingURL=shared.js.map